import { useState } from "react";

import { LoaderCircle } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Dialog } from "@/components/ui/dialog";

import { useServiceWorker } from "./useServiceWorker";

function ReloadPrompt() {
  const [loading, setLoading] = useState<boolean>(false);
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useServiceWorker();

  const handleUpdateClick = async () => {
    setLoading(true);
    await updateServiceWorker().finally(() => {
      setLoading(false);
    });
  };

  return (
    <Dialog open={needRefresh}>
      <Dialog.Content
        className="flex h-fit max-h-[80%] max-w-sm flex-col md:max-w-lg"
        nonDismissable
      >
        <Dialog.Header className="block">
          <Dialog.Title>New Update Available</Dialog.Title>
        </Dialog.Header>
        A new update is available. To continue using the app, please click the
        update button.
        <Dialog.Footer className="flex flex-row justify-end">
          <Button
            variant="outline"
            onClick={handleUpdateClick}
            disabled={loading}
          >
            {loading ? (
              <LoaderCircle className="h-4 w-4 animate-spin" />
            ) : (
              "Update"
            )}
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  );
}

export default ReloadPrompt;
